import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=61164cb0&"
import script from "./TabContent.vue?vue&type=script&lang=js&"
export * from "./TabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports